import { render, staticRenderFns } from "./force-update.vue?vue&type=template&id=056a1137&scoped=true"
import script from "./force-update.vue?vue&type=script&lang=js"
export * from "./force-update.vue?vue&type=script&lang=js"
import style0 from "./force-update.vue?vue&type=style&index=0&id=056a1137&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056a1137",
  null
  
)

export default component.exports